<form [formGroup]="form" class="dynamic-search-form">
  <div class="dsf-row" *ngFor="let row of chunkedConfig" [ngClass]="{'info-tooltip-adjust': hasInfoTooltip(row)}">
    <ng-container *ngFor="let field of row">
      <div class="dsf-col">
        <div class="form-label mb-2 font-weight-500">
          {{ field.label }}
          <ng-container *ngIf="field.datatype === 'dropdown' && field.showInfoTooltip && field.info">
            <span
              class="info-tooltip-arrow-wrapper info-tooltip-icon"
              [class.tooltip-open]="infoTooltip._isTooltipVisible()"
              matTooltip="{{ field.info }}"
              matTooltipPosition="ab.pngove"
              #infoTooltip="matTooltip"
              (click)="infoTooltip.show()"
              tabindex="0"
              (keypress)="infoTooltip.show()"
            >&#9432;
              <span class="tooltip-arrow-inverted"></span>
            </span>
          </ng-container>
          <span *ngIf="field.validation?.includes('required')" class="error">*</span>
        </div>
        <ng-container [ngSwitch]="field.datatype">
          <ng-container *ngSwitchCase="'text'">
            <ng-container *ngIf="field.fieldName === 'ssn_number'; else regularText">
              <input [type]="'text'" [disabled]="field.disabled" [inputFocus]="field.enableInputFocus"
                [loadErrorMessages]="field.loadErrorMessages" [formControlName]="field.fieldName"
                [attr.placeholder]="field.placeholder" [attr.maxlength]="field.maxLength || null"
                (keypress)="(field.pattern === 'onlyNumber' ? onlyNumbers($event) : true)"/>
            </ng-container>
            <ng-template #regularText>
              <input [type]="'text'" [disabled]="field.disabled" [value]="field.value"
                [inputFocus]="field.enableInputFocus" [loadErrorMessages]="field.loadErrorMessages"
                [formControlName]="field.fieldName" [attr.placeholder]="field.placeholder"
                [attr.maxlength]="field.maxLength || null" [attr.minlength]="field.minLength || null"
                (keypress)="field.fieldName === 'license_number' ? onlyNumbers($event) : (field.pattern === 'onlyNumber' || field.inputPattern === 'onlyNumber' ? onlyNumbers($event) : true)"/>
                <!-- [ngClass]="{'is-invalid ': showEmailValidation && field.fieldName === 'primary_email' && form.get(field.fieldName)?.invalid && form.get(field.fieldName)?.touched && !(form.get(field.fieldName)?.value?.includes('*'))}" />
                  <div *ngIf="field.fieldName === 'primary_email' && showEmailValidation && form.get(field.fieldName)?.invalid && form.get(field.fieldName)?.touched && !(form.get(field.fieldName)?.value?.includes('*')) && (form.get(field.fieldName)?.errors?.['email'] || form.get(field.fieldName)?.errors?.['pattern'])" class="email-error-placeholder text-danger mt-1 marging_input">
                    Please enter a valid email address.
                  </div> -->
            </ng-template>
          </ng-container>
          <div *ngSwitchCase="'date'" class="input-group">
            <input class="form-control" [attr.placeholder]="field.placeholder" type="text" [disabled]="field.disabled"
              [formControlName]="field.fieldName" appDateMask [noFutureDate]="field.noFutureDate"
              (dateMaskError)="dateMaskError = $event" #dateTextInput [inputFocus]="field.enableInputFocus"
              [loadErrorMessages]="field.loadErrorMessages" maxlength="10" />
            <div class="input-group-append relative">
              <span class=" calendar-input-icon" (click)="!field.disabled && dateTextInputHidden.click()">
                <i class="fa fa-calendar" tabindex="0" (keydown.enter)="!field.disabled && dateTextInputHidden.click()" [ngClass]="{'disabled-icon': field.disabled}"></i>
                <input type="date" #dateTextInputHidden
                  (change)="onDateIconSelect(dateTextInputHidden.value, dateTextInput,field.fieldName)"
                  class="calendar-icon" [attr.max]="field.noFutureDate ? todayString : null" [disabled]="field.disabled" tabindex="-1" />
              </span>
            </div>
          </div>
          <div *ngIf="form.get(field.fieldName)?.invalid && form.get(field.fieldName)?.touched"
            class="text-danger mt-1">
            <span *ngIf="form.get(field.fieldName)?.errors?.['futureDate']">Future dates are not allowed</span>
            <div *ngIf="useValidSearchInput"><span *ngIf="form.get(field.fieldName)?.errors?.['invalidDate']">Invalid
                date format</span></div>
          </div>
          <!-- Date Range Field -->
          <div *ngSwitchCase="'daterange'" class="date-range-container position-relative">
            <p-calendar
              [formControlName]="field.fieldName"
              selectionMode="range"
              [showIcon]="field.showIcon"
              [showOnFocus]="field.showOnFocus"
              [placeholder]="field.placeholder"
              dateFormat="mm/dd/yy"
              [maxDate]="field.noFutureDate ? maxDate : null"
              [disabled]="field.disabled"
              [readonlyInput]="field.readonly"
              inputId="{{field.fieldName}}-range"
              styleClass="date-range-calendar"
              aria-label="{{field.label}} date range picker"
              [attr.aria-required]="field.validation?.includes('required') ? 'true' : null"
              [attr.aria-invalid]="form.get(field.fieldName)?.invalid && form.get(field.fieldName)?.touched ? 'true' : 'false'"
              role="group"
            >
            </p-calendar>
            <button *ngIf="form.get(field.fieldName)?.value" type="button" class="clear-icon date-range-clear cross-icon" tabindex="-1" (click)="clearDateRange(field); $event.stopPropagation()" aria-label="Clear selection">
              <img src="assets/images/close.png" alt="Clear" style="width: 16px; height: 16px; vertical-align: middle;" />
            </button>
            <div *ngIf="form.get(field.fieldName)?.invalid && form.get(field.fieldName)?.touched"
              class="text-danger mt-1">
              <span *ngIf="form.get(field.fieldName)?.errors?.['futureDate']">Future dates are not allowed</span>
            </div>
          </div>
          <div *ngSwitchCase="'dropdown'">
            <div class="dropdown-clear-wrapper mt-1">
                    <select [formControlName]="field.fieldName"
                      class="form-control"
                      tabindex="0"
                      [disabled]="field.disabled"
                      [style.color]="form.get(field.fieldName)?.value === null || form.get(field.fieldName)?.value === '' ? '#757575' : '#010101'"
                      [ngClass]="{'empty-select': form.get(field.fieldName)?.value === null || form.get(field.fieldName)?.value === ''}"
                      (change)="(field.fieldName === 'license_kind' || field.fieldName === 'endorsement_type') ? onDropdownChange(field, $event) : null">
                <option *ngIf="field.placeholder" hidden disabled selected [ngValue]="null" style="color: #757575 !important;">{{ field.placeholder }}</option>
                <option *ngFor="let opt of field.filteredOptions || field.options" [value]="opt.value" [disabled]="opt.disabled">{{opt.label}}</option>
              </select>
              <!-- <button *ngIf="form.get(field.fieldName)?.value" type="button" class="clear-icon" tabindex="-1" (click)="clearDropdown(field); $event.stopPropagation()" aria-label="Clear selection">
                <img src="assets/images/close.png" alt="Clear" style="width: 16px; height: 16px; vertical-align: middle;" />
              </button> -->
            </div>
          </div>
          <div *ngSwitchCase="'multiselectdropdown'" class="multiselect-wrapper" [class.open]="field['_open']" (click)="onMultiselectWrapperClick(field, $event)">
            <div class="multiselect-select-box" tabindex="0" (keydown.enter)="toggleMultiselect(field)">
              <span *ngIf="!(form.get(field.fieldName)?.value?.length)" class="multiselect-placeholder">{{ field.placeholder || 'Select' }}</span>
              <span *ngIf="form.get(field.fieldName)?.value?.length" class="multiselect-chips">
                <span *ngFor="let val of form.get(field.fieldName)?.value" 
                      class="multiselect-chip"
                      [matTooltip]="getChipLabel(field, val)"
                      [matTooltipDisabled]="!needsTooltip(getChipLabel(field, val))"
                      matTooltipPosition="above">
                  {{ getChipDisplayLabel(field, val) }}
                  <button type="button" class="multiselect-chip-remove" (click)="removeChip(field, val, $event)">&times;</button>
                </span>
              </span>
              <span class="multiselect-arrow"></span>
            </div>
            <button *ngIf="form.get(field.fieldName)?.value?.length" type="button" class="multiselect-clear" tabindex="-1"
              (click)="clearMultiselect(field); $event.stopPropagation()" aria-label="Clear all">&times;</button>
            <div class="multiselect-dropdown-panel" *ngIf="field['_open']">
              <div class="multiselect-search-box">
                <input type="text" class="multiselect-search-input" placeholder="Search..." [value]="field['_searchText'] || ''"
                  (input)="onMultiselectSearch(field, $event)" (click)="$event.stopPropagation()" />
              </div>
              <div class="multiselect-options-list">
                <label *ngFor="let opt of getFilteredMultiselectOptions(field)" class="multiselect-option" (click)="$event.stopPropagation()">
                  <input type="checkbox" [checked]="isMultiselectOptionSelected(field, opt.value)"
                    (change)="onMultiselectOptionToggle(field, opt.value, $event)" />
                  <span class="multiselect-option-label">{{ opt.label }}</span>
                </label>
                <div *ngIf="getFilteredMultiselectOptions(field).length === 0" class="multiselect-no-results">No results found</div>
              </div>
            </div>
          </div>
          <ng-container *ngSwitchDefault>
            <input [type]="field.mask ? 'password' : 'text'" [formControlName]="field.fieldName"
              [attr.placeholder]="field.placeholder"
              [ngClass]="{'is-invalid': form.get(field.label)?.touched && form.get(field.label)?.invalid}"
              [inputFocus]="field.enableInputFocus" [loadErrorMessages]="field.loadErrorMessages" />
          </ng-container>
        </ng-container>
      </div>
   </ng-container>
  </div>
  <div class="button-row d-flex mt-3 justify-content-end mb-3" *ngIf="buttonLabel">
    <button type="button" class="btn btn-outline btn-width-100 btn-modal-action me-3 btn-radius"
      (click)="reset()" [disabled]="!formTouched">Reset</button>
    <button type="button" class="btn btn-primary btn-width-100 btn-modal-action ml-0 btn-radius" (click)="search()"
      [disabled]="isSearch() || disableSearchButton">Search</button>
  </div>
</form>